export default __webpack_public_path__ + "static/9-69ffd211b9b0f4d3a424462311baee11.png";